/* eslint-disable @typescript-eslint/no-explicit-any */
import { cva, type VariantProps } from 'class-variance-authority'

export const headerVariants = cva('', {
  variants: {
    align: {
      start: 'text-left',
      center: 'text-center',
      end: 'text-right',
    },
  },
  defaultVariants: {
    align: 'start',
  },
})

export type TableHeaderVariants = VariantProps<typeof headerVariants>

export type TableSortOption = 'asc' | 'desc' | undefined
export type TableSorts = Record<string, TableSortOption>

export type TableHeaderOptions = {
  align?: TableHeaderVariants['align']
  key: string
  sortKey?: string
  truncate?: boolean
  width?: string
  sortable?: boolean
  title?: string
  formatter?: (value: any, item: any) => string
}

export type TableFilterOperator = 'range' | 'greater' | 'greater_than_or_equal_to' | 'less' | 'less_than_or_equal_to' | 'equal'
export const relativeValues = ['yesterday', 'today', 'tomorrow'] as const
export type TableFilterRelativeValue = (typeof relativeValues)[number]

export interface TableFilterOptions {
  id: string
  label?: string
  type?: 'select' | 'text' | 'date' | 'number'
  operators?: TableFilterOperator[]
  operator?: TableFilterOperator
  url?: string
  data?: TableFilterValue
  options?: Record<string, string> | unknown[]
  multiple?: boolean
  placeholder?: string
  description?: string
  fillable?: boolean
  visible?: boolean
}

export type TableFilterValue = TableFilterValueGeneric | TableFilterValueOption | TableFilterValueOptions

export type TableFilterValueGeneric = number | string | boolean
export type TableFilterValueOption = {
  values: string
  operator?: TableFilterOperator
}

export type TableFilterValueOptions = {
  values: string[]
  operator?: TableFilterOperator
}

export { default as AModelTable, type AModelTableExpose } from './AModelTable.vue'
export { default as ATableActions } from './ATableActions.vue'
export { useGetFilterValueLabel, useTableResponsive } from './composables.ts'
export { default as DataTableDropdown } from './DataTableDropdown.vue'
export type { TableRowEvent, TableSearchEvent, TableSortEvent } from './Table.vue'
export { default as Table } from './Table.vue'
export { default as TableBase } from './TableBase.vue'
export { default as TableBody } from './TableBody.vue'
export { default as TableCaption } from './TableCaption.vue'
export { default as TableCell } from './TableCell.vue'
export { default as TableEmpty } from './TableEmpty.vue'
export { default as TableFooter } from './TableFooter.vue'
export { default as TableHead } from './TableHead.vue'
export { default as TableHeader } from './TableHeader.vue'
export { default as TableLoader } from './TableLoader.vue'
export { default as TablePageSizeSelect } from './TablePageSizeSelect.vue'
export { default as TablePagination } from './TablePagination.vue'
export { default as TablePaginationButtons } from './TablePaginationButtons.vue'
export { default as TablePaginationOld } from './TablePaginationOld.vue'
export { default as TableRow } from './TableRow.vue'
export { default as TableSearch } from './TableSearch.vue'
export { default as TableSortIcon } from './TableSortIcon.vue'
